import identityCard from './identityCard'

const mobileReg = /^1[3|4|5|6|7|8|9]\d{9}$/
const cidReg = /^\d{10}$/

export default function (value) {
  const len = value.length

  if (len === 10) {
    if (cidReg.test(value)) {
      return {
        validate: true
      }
    } else {
      return {
        validate: false,
        message: '金鹏卡号为10位数字'
      }
    }
  }

  if (len === 11) {
    if (mobileReg.test(value)) {
      return {
        validate: true
      }
    } else {
      return {
        validate: false,
        message: '请输入正确的手机号码'
      }
    }
  }

  if (len === 18) {
    return identityCard(value)
  }

  return {
    validate: false,
    message: '请输入正确的金鹏卡号/手机/身份证号'
  }
}
